import * as React from "react";

const useProgress = (animate, time) => {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    let rafId = 0;
    let start = 0;
    if (animate) {
      const step = timestamp => {
        if (!start) start = timestamp;
        const newProgress = timestamp - start;
        setProgress(newProgress);
        if (newProgress < time) {
          rafId = requestAnimationFrame(step);
        }
      };
      rafId = requestAnimationFrame(step);
    }
    return () => cancelAnimationFrame(rafId);
  }, [animate, time]);

  return animate
    ? Math.min(progress / time, time)
    : 0;
};

export default useProgress;